import { useTranslations } from '@vocab/react';
import { Box, Stack, Text } from 'braid-design-system';
import type { FC } from 'react';

import { PersonWithLaptopIllustration } from 'src/libs/Illustrations';

import translations from './.vocab';

export const VerificationsErrorState: FC = () => {
  const { t } = useTranslations(translations);
  return (
    <Box display="flex" justifyContent="center">
      <Box maxWidth="small" data={{ testid: 'verifications-error' }}>
        <Stack space="small" align="center">
          <PersonWithLaptopIllustration height={128} width={128} />
          <Text weight="strong">
            {t("Verified credentials aren't available")}
          </Text>
          <Text>
            {t(
              "We can't show you verified credentials right now. We're doing our best to fix this. Try refreshing the page or check back later.",
            )}
          </Text>
        </Stack>
      </Box>
    </Box>
  );
};
